"use client";
import { useEffect } from "react";
import { useState } from "react";
import { ProductSlim } from "~/use-cases/contracts/Product";

type LipscoreReviewProps = {
  product: ProductSlim;
};

const LipScoreReviewSmall = ({ product }: LipscoreReviewProps) => {
  const [productUrl, setProductUrl] = useState<string>("");

  useEffect(() => {
    setProductUrl(window.location.href);
  });
  return (
    <div className="lipscore-stars">
      <span
        className="lipscore-rating-small"
        data-ls-product-name={product?.name}
        data-ls-brand={product?.brand?.content?.text}
        data-ls-product-id={product?.sku}
        data-ls-product-url={productUrl}
      ></span>
    </div>
  );
};

export default LipScoreReviewSmall;
